declare let process: any;
const env = process.env.NODE_ENV;

export const environment = {
  saasURL: 'https://prodump.glamera.com',
  apiGlamatech: 'https://api-prodump.glamera.com/api/v5/b2c/rl',
  apiApplication: 'https://api-prodump-new.glamera.com/api',
  RootDomain: "glamera.com",
};

